import { defineComponent as _defineComponent } from 'vue'
import Cleave from "vue-cleave-component";
  import { computed, reactive, ref, watch } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { email, required } from "@vuelidate/validators";
  import { validPhoneNumber } from "@/helpers/validation";
  import store from "@/store";
  import router from "@/router";
  import { CreateUser } from "@/types/CreateUser";
  import { UserRoles } from "@/enums/UserRoles";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { useRoleByRouteInAdmin } from "@/features/useRoleByRouteInAdmin";
  import { UserTier } from "@/enums/UserTier";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminUserCreate',
  setup(__props, { expose: __expose }) {
  __expose();

  const { roleByRoute } = useRoleByRouteInAdmin();

  const headerText = computed(() => {
    return roleByRoute.value === UserRoles.LAWYER
      ? "Add Contact person (Trust account)"
      : "Add Land Owner";
  });
  const form = reactive({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    tier: UserTier.OFF,
  });
  const rules = computed(() => {
    return {
      firstName: { required, $autoDirty: true },
      lastName: { required, $autoDirty: true },
      email: { required, email, $autoDirty: true },
      phone: { validPhoneNumber, $autoDirty: true },
      tier: { required, $autoDirty: true },
    };
  });
  const v$ = useVuelidate(rules, form);
  const emailError = ref("");

  watch(
    () => router.currentRoute.value,
    (value) => {
      roleByRoute.value =
        value.meta.role && value.meta.role === UserRoles.LAWYER
          ? UserRoles.LAWYER
          : UserRoles.LANDOWNER;
    },
    {
      immediate: true,
    }
  );

  const createUser = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) {
      return;
    }

    const user: CreateUser = {
      firstName: form.firstName,
      middleName: form.middleName,
      lastName: form.lastName,
      email: form.email.toLowerCase(),
      phone: form.phone,
      role: roleByRoute.value,
    };

    store
      .dispatch("user/createUser", user)
      .then((res) => {
        router.push({
          name:
            roleByRoute.value === UserRoles.LAWYER
              ? "AdminLawyerDetailsUpdate"
              : "AdminLandownerDetailsUpdate",
          params: {
            userId: res.data._id,
          },
        });
      })
      .catch((error) => {
        if (error.response.data.message) {
          emailError.value = error.response.data.message;
        }
      });
  };

const __returned__ = { roleByRoute, headerText, form, rules, v$, emailError, createUser, get Cleave() { return Cleave }, computed, reactive, ref, watch, get useVuelidate() { return useVuelidate }, get email() { return email }, get required() { return required }, get validPhoneNumber() { return validPhoneNumber }, get store() { return store }, get router() { return router }, get CreateUser() { return CreateUser }, get UserRoles() { return UserRoles }, get phoneNumberOption() { return phoneNumberOption }, get useRoleByRouteInAdmin() { return useRoleByRouteInAdmin }, get UserTier() { return UserTier } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})